{
  "drawMoreButton": "disegnare più campi",
  "drawPolygonInstructions": "Disegna il tuo poligono toccando la mappa.",
  "fieldLabelsToggle": "Mostra/nascondi le etichette dei campi",
  "fieldTypePolygon": "Poligono",
  "helpBodyText": "Crea campi per rappresentare le aree della tua fattoria. I campi vengono utilizzati per tracciare gli eventi di irrigazione e di attrezzature.",
  "helpTitle": "Informazioni sulla creazione di campi",
  "linkTo": "Nuovo campo",
  "manageFieldButton": "Gestisci campo",
  "notEnoughPoints": "Assicurati che il tuo campo abbia almeno 3 punti e sia chiuso.",
  "restartButtonText": "Ricomincia",
  "retartButton": "Ricominciare",
  "setNameInstructions": "Inserisci un nome per il tuo campo.",
  "setRowDirectionInstructions": "Utilizza il cursore per impostare la direzione della riga del tuo campo.",
  "successInstructions": "Il tuo campo è stato creato.",
  "title": "Nuovo campo",
  "undoButtonText": "Disfare"
}
